<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Add New Sales Profile</h2>
        <sales-profile-form button_text="Add Sales Profile" @SalesProfileAction="SalesProfileAction"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import SalesProfileForm from "@/components/customers/sales-profile-form";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  page: {
    title: "Create Sales Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {SalesProfileForm, PageHeader, Layout},
  name: "create-sales-profile",
  data() {
    return {
      title: "Create Sales Profile",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Create Sales Profile",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addSalesProfile: 'customers/addNewSalesProfile',
    }),
    async SalesProfileAction(data){
      await this.addSalesProfile(data).then(resp => {
        if(resp.publicId){
          successToast('New Sales Profile added successfully')
          this.$router.push(routeItems.single_sales_profile_route+'/'+resp.publicId)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
